import { lazy, Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'
import { DEFAULT_AU_REPORT_CODE, DEFAULT_NZ_REPORT_CODE } from 'constants/reportDefaults'
import LoadingPanel from 'cec-commons-loading-panel'

const PreviewAUPage = lazy(() => import('pages/Preview/PreviewAU'))
const PreviewNZPage = lazy(() => import('pages/Preview/PreviewNZ'))
const LeadGenPage = lazy(() => import('pages/LeadgenPage'))
const PreviewBrandedReport = lazy(() => import('pages/Preview/PreviewBrandedReport'))
const PropertySearchPage = lazy(() => import('pages/PropertySearchPage'))
const PropertyAdvancedSearchPage = lazy(() => import('pages/PropertyAdvancedSearchPage'))
const ReportPage = lazy(() => import('pages/HomePage'))

const PageNotFound = lazy(() => import('pages/PageNotFound'))

const Routes = () => (
  <Suspense fallback={
    <div data-testid='page-loading'>
      <LoadingPanel isLoading />
    </div>
  }
  >
    <Switch>
      <Route
        exact
        path={`/dpr/${DEFAULT_AU_REPORT_CODE}`}
        component={PreviewAUPage}
      />
      <Route
        exact
        path={`/dpr/${DEFAULT_NZ_REPORT_CODE}`}
        component={PreviewNZPage}
      />
      <Route
        exact
        path='/dpr/:code'
        component={ReportPage}
      />
      <Route
        exact
        path='/preview/:integratorShortName'
        component={PreviewBrandedReport}
      />
      <Route
        exact
        path='/:integratorShortName/details/'
        component={LeadGenPage}
      />
      <Route
        exact
        path='/:integratorShortName/'
        component={PropertySearchPage}
      />
      <Route
        exact
        path='/:integratorShortName/advanced-search'
        component={PropertyAdvancedSearchPage}
      />
      <Route path='*' component={PageNotFound} />
    </Switch>
  </Suspense>
)

export { Routes }
export default Routes
